module.exports = __webpack_public_path__ + "img/comment.10ce48fa.svg";